import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import('./style.scss');
import { Carousel } from 'primereact/carousel';
import { ProgressSpinner } from 'primereact/progressspinner';

const PhotoCarousel = () => {
  const [photos, setPhotos] = useState([]);
  const [album, setAlbum] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRecentAlbum = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await fetch('/api/flickr/recent_album_photos');
        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.error || 'Unable to load recent photos');
        }

        setAlbum(data.album);
        setPhotos(data.photos || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchRecentAlbum();
  }, []);

  const responsiveOptions = [
    {
      breakpoint: '1199px',
      numVisible: 1,
      numScroll: 1
    },
    {
      breakpoint: '991px',
      numVisible: 1,
      numScroll: 1
    },
    {
      breakpoint: '575px',
      numVisible: 1,
      numScroll: 1
    }
  ];

  const photoTemplate = (photo) => (
    <figure className='photo-carousel__figure'>
      <img
        className='photo-carousel__image'
        src={photo.src}
        alt={photo.title || 'Young Israel event photograph'}
      />
    </figure>
  );

  if (loading) {
    return (
      <div className='photo-carousel__loading'>
        <ProgressSpinner aria-label='Loading recent photos' />
      </div>
    );
  }

  if (error || photos.length === 0) {
    return (
      <p className='photo-carousel__empty'>
        {error || 'Recent photos will appear here soon.'}
      </p>
    );
  }

  return (
    <div className='photo-carousel'>
      <Carousel
        autoFocus
        value={photos}
        numVisible={1}
        numScroll={1}
        responsiveOptions={responsiveOptions}
        autoplayInterval={3500}
        circular
        showIndicators={false}
        itemTemplate={photoTemplate}
      />
      {album?.title && (
        <p className='photo-carousel__caption'>
          From <Link to={`/events/pictures?album=${album.id}`}>{album.title}</Link>
        </p>
      )}
    </div>
  );
};

export default PhotoCarousel;
